module.exports = __webpack_public_path__ + "src/assets/images/icon_speech_bubbles.svg?6e29348a3d83eb798a329b31d5371cda";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_speech_bubbles.svg
// module id = 1010
// module chunks = 1